import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FONTS from '@mlb/react-patterns/style/fonts.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';
import Icon from '@mlb/react-patterns/components/Icon/icon.tsx';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Label = styled.span`
    display: inline-block;
    margin-left: 6px;
    color: ${COLORS.mlbWhite};
    font-family: ${FONTS.primaryFont};
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
`;

const Clock = (props) => {

    const {
        dictionary,
        loading,
        startTime,
        endTime,
    } = props;

    if (loading) {

        return null;

    }

    return (
        <Wrapper>
            <Icon
                name={'clock-outline'}
                fill={COLORS.liveYellow}
                width={14}
            />
            <Label>
                {`${Math.round(endTime - startTime)} ${dictionary.secs_total || 'secs total'}`}
            </Label>
        </Wrapper>
    );

};

Clock.propTypes = {
    dictionary: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    startTime: PropTypes.number.isRequired,
    endTime: PropTypes.number.isRequired,
};

export default Clock;
